import React from "react";
import { monthFormatter } from "./HDBSchema";

function getFieldCode(code) {
  return code.replace(/^HB_/, "").replace(/_HBD$/, "");
}
function getSingleSection(columns) {
  return {
    heights: { header1: "auto", header2: "auto" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: columns,
  };
}

function getColsSchema(Rule, RowSpan, Item, index) {
  const { code, description, number, alias } = Item;
  const FieldCode = `test${getFieldCode(code)}`;
  let columns = [];
  if (index === 0) {
    columns.push({ title: Rule, colSpan: 3, rowSpan: RowSpan, isTitleOnly: true, unBold: true, className: "tbl-text-normal" });
  }
  // columns.push({ title: alias || number, colSpan: 3, rowSpan: 1, isTitleOnly: true, unBold: true, className: "tbl-text-normal" });
  for (let i = 1; i <= 12; i++) {
    columns.push({
      title: "Month",
      colSpan: 1,
      formatter: (val) => monthFormatter(val, i),
      dontJoinValues: true,
      accessor: [FieldCode],
      rowSpan: 1,
      isValueOnly: true,
      unBold: true,
      className: "tbl-text-normal",
    });
  }
  columns.push({
    title: description,
    colSpan: 5,
    rowSpan: 1,
    isTitleOnly: true,
    leftAlign: true,
    unBold: true,
    className: "tbl-text-normal",
  });
  return columns;
}

function getSectionSchema(Section) {
  const SectionList = [];
  const { Rule, Items, sect } = Section;
  if (Rule === "onlyHeaderDisplay") {
    return [sect];
  }
  const RowSpan = Items.length;
  Items.forEach((element, index) => {
    let cols = getColsSchema(Rule, RowSpan, element, index);
    let sec = getSingleSection(cols);
    SectionList.push(sec);
  });
  return SectionList;
}

export function getSchemaForRows() {
  const MainSectionList = [];
  for (let item of LookupData) {
    let Section = getSectionSchema(item);
    MainSectionList.push(...Section);
  }
  return MainSectionList;
}

export const LookupData = [
  {
    Rule: "Track",
    Items: [
      {
        description: "Drainage",
        code: "HB_tr0a1_HBD",
      },
      {
        description: "Track Condition",
        code: "HB_tr1a2_HBD",
      },
      {
        description: "Anchors & MSR tie plates",
        code: "HB_tr2a3_HBD",
      },
    ],
  },
  {
    Rule: "Bearing Scanners",
    Items: [
      {
        description: "Clearance to the ballast",
        code: "HB_be0a4_HBD",
      },
      {
        description: "Clearance to track hardware",
        code: "HB_be1a5_HBD",
      },
      {
        description: "Clearance to ties",
        code: "HB_be2a6_HBD",
      },
      {
        description: "Heaters",
        code: "HB_be3a7_HBD",
      },
      {
        description: "Rail mount secured",
        code: "HB_be4a8_HBD",
      },
      {
        description: "Scanner deflectors",
        code: "HB_be5a9_HBD",
      },
      {
        description: "Clean lens, mirrors",
        code: "HB_be6a10_HBD",
      },
      {
        description: "Connections tighten",
        code: "HB_be7a11_HBD",
      },
    ],
  },
  {
    Rule: "Transducers",
    Items: [
      {
        description: "Rail mount secured",
        code: "HB_tr0a12_HBD",
      },
      {
        description: "Activation",
        code: "HB_tr1a13_HBD",
      },
      {
        description: "Free of metallic objects",
        code: "HB_tr2a14_HBD",
      },
      {
        description: "Connections tighten",
        code: "HB_tr3a15_HBD",
      },
    ],
  },
  {
    Rule: "DED",
    Items: [
      {
        description: "Full movement of paddle",
        code: "HB_de0a16_HBD",
      },
      {
        description: "Activation force",
        code: "HB_de1a17_HBD",
      },
      {
        description: "Damaged panels replacement",
        code: "HB_de2a18_HBD",
      },
      {
        description: "Paint panels",
        code: "HB_de3a19_HBD",
      },
      {
        description: "Scanner mount secured",
        code: "HB_de4a20_HBD",
      },
    ],
  },
  {
    Rule: "Hot Wheel Scanners",
    Items: [
      {
        description: "Clean lens, mirrors",
        code: "HB_ho0a21_HBD",
      },
      {
        description: "Connections tighten",
        code: "HB_ho1a22_HBD",
      },
      {
        description: "Check for moisture / heaters",
        code: "HB_ho2a23_HBD",
      },
      {
        description: "Cleanliness",
        code: "HB_ho3a24_HBD",
      },
      {
        description: "Calibrate scanners",
        code: "HB_ho1b4_HBD",
      },
    ],
  },
  {
    Rule: "Bungalow",
    Items: [
      {
        description: "Confirm AC/DC voltages - refer to SSIT 203 and Battery card",
        code: "HB_bu0a25_HBD",
      },
      {
        description: "Calibration assistant properly stored",
        code: "HB_bu1a26_HBD",
      },
      {
        description: "Temperature sensor",
        code: "HB_bu2a27_HBD",
      },
      {
        description: "Monthly Test Train",
        code: "HB_bu3a28_HBD",
      },
      {
        description: "Review Train logs",
        code: "HB_bu4a29_HBD",
      },
    ],
  },
  {
    Rule: "onlyHeaderDisplay",
    sect: {
      heights: { header1: "auto", header2: "auto" },
      classes: { header1: "" },
      inlineBodyData: true,
      columns: [{ title: "6 Month", colSpan: 20, rowSpan: 1, isTitleOnly: true, className: "tbl-text-normal" }],
    },
  },
  {
    Rule: "Track",
    Items: [
      {
        description: "Proper Signage Installed - Markers",
        code: "HB_tr1na_HBD",
      },
      {
        description: "Track Connections (Track Hardware - Visual)",
        code: "HB_tr2na_HBD",

        alias: "N/A",
      },
    ],
  },

  {
    Rule: "Bearing Scanners",
    Items: [
      {
        description: "Mouse screen installed",
        code: "HB_be0b1_HBD",
      },
      {
        description: "Rail to scanner impedance",
        code: "HB_be1b2_HBD",
      },
      {
        description: "Calibrate scanners",
        code: "HB_be2b3_HBD",
      },
    ],
  },

  {
    Rule: "Bungalow",
    Items: [
      {
        description: "Alarm threshold",
        code: "HB_bu1b5_HBD",
      },
      {
        description: "Radio test",
        code: "HB_bu1b6_HBD",
      },
    ],
  },
  {
    Rule: "onlyHeaderDisplay",
    sect: {
      heights: { header1: "auto", header2: "auto" },
      classes: { header1: "" },
      inlineBodyData: true,
      columns: [{ title: "1 Year", colSpan: 20, rowSpan: 1, isTitleOnly: true, className: "tbl-text-normal" }],
    },
  },
  {
    Rule: "Bungalow",
    Items: [
      {
        description: "Condition of Plans",
        code: "HB_bu0ssit1001e7_HBD",
      },
      {
        description: "Cable Housings",
        code: "HB_bu1ssit901_HBD",
      },
    ],
  },
  {
    Rule: "Bearing Scanners",
    Items: [
      {
        description: "Tighten Pyro / Bolometer block",
        code: "HB_be3b4_HBD",
      },
      {
        description: "Scanners alignment",
        code: "HB_be4b5_HBD",
      },
    ],
  },
  {
    Rule: "Transducers",
    Items: [
      {
        description: "Polarity check on gating",
        code: "HB_tr0b6_HBD",
      },
      {
        description: "Gating transducer spacing",
        code: "HB_tr1b7_HBD",
      },
    ],
  },
  {
    Rule: "DED",
    Items: [
      {
        description: "Top of rail clearance",
        code: "HB_tr2b8_HBD",
      },
      {
        description: "Paddle height",
        code: "HB_de0b9_HBD",
      },
      {
        description: "Contact adjustment",
        code: "HB_de1b10_HBD",
      },
      {
        description: "Clearance & movement",
        code: "HB_de2b11_HBD",
      },
      {
        description: "Inspect bearings & grease",
        code: "HB_de3b12_HBD",
      },
      {
        description: "Tighten All Terminals Internal to DED",
        code: "HB_de4b13_HBD",
      },
    ],
  },
  {
    Rule: "Hot Wheel Scanners",
    Items: [
      {
        description: "Scanner Alignment Check",
        code: "HB_ho0b14_HBD",
      },
      {
        description: "Tighten Pyro / Bolometer block",
        code: "HB_ho2b16_HBD",
      },
    ],
  },
  {
    Rule: "Bungalow",
    Items: [
      {
        description: "Tighten all connections",
        code: "HB_bu3b20_HBD",
      },
    ],
  },
  {
    Rule: "onlyHeaderDisplay",
    sect: {
      heights: { header1: "auto", header2: "auto" },
      classes: { header1: "" },
      inlineBodyData: true,
      columns: [{ title: "400 Series", colSpan: 20, rowSpan: 1, isTitleOnly: true, className: "tbl-text-normal" }],
    },
  },
  {
    Rule: "Bungalow & Structures & Scanners",
    Items: [
      {
        description: "Inspect Foundations",
        code: "HB_bu0ssit1101_HBD",
      },
      {
        description: "Painted Surfaces",
        code: "HB_bu1ssit1103_HBD",
      },
      {
        description: "Inspect Seals and Specs",
        code: "HB_bu2ssit1104_HBD",
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/Reports/HighBall/HBDReport/SchemaGenerator.jsx